import { MY_WORK_CLOSED_GROUPS_LOCALSTORAGE } from '../types';
import { IMyWorkClosedGroups } from '../../types';

export const setClosedGroupsLocalStorage = (
    openedGroups: IMyWorkClosedGroups
) => {
    localStorage.setItem(MY_WORK_CLOSED_GROUPS_LOCALSTORAGE, JSON.stringify(openedGroups));
}
